import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const InputWrapper = styled.div`
  display: grid;
  grid-template-rowd: 1fr 1fr;

  .input-inner-wrapper {
    display: flex;
    margin-bottom: 16px;
    width: 100%;
    .input-name, .input-phone {
      width: 49%;
    }

    .input-name {
      display: flex;
      flex-direction: column;
      align-items: start;
      margin-right: 16px;

      @media (max-width: ${defaultBreakpoints.medium}) {
        margin-bottom: 16px;
        margin-right: 0;
      }
    }
    
    @media (max-width: ${defaultBreakpoints.medium}) {
      margin: 0 0 16px 0;
      width: 100%;
      flex-direction: column;

      .input-name, .input-phone {
        width: 100%;
      }
    }
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`;

export const SelectWrapper = styled.div`
  width: 45%;
  margin-bottom: 1rem;
  @media (max-width: ${defaultBreakpoints.medium}) {
    width: 100%;
  }
`;

export const Title = styled.h1`
  margin-top: 32px;
`;
